import { FC, useState } from 'react';

import { useQuery } from '@apollo/client';

import { SaleBidderLevel } from '__generated__/globalTypes';

import { SaleDocuments, SaleDocumentsVariables } from 'query/__generated__/saleDataRoom';
import { SALE_DOCUMENTS_QUERY } from 'query/saleDataRoom';

import { DATA_ROOM_HEADING } from './BidderDataRoom';
import { ReviewCopyDataRoom } from './SaleApprovalPanel';

export const SELLER_DATA_ROOM_NOTE =
  "You're viewing your sale's data room. Documents open as review copies and are logged.";

export const SELLER_REVIEWER_GRANT_NOTE =
  'Opening documents needs a reviewer grant from an Orsnn operator.';

export const SellerDataRoom: FC<{ saleId: string }> = ({ saleId }) => {
  const [viewAs, setViewAs] = useState<SaleBidderLevel>(SaleBidderLevel.L2);
  const dataRoomQuery = useQuery<SaleDocuments, SaleDocumentsVariables>(SALE_DOCUMENTS_QUERY, {
    variables: { saleId, viewAs },
    errorPolicy: 'all',
  });

  return (
    <section
      data-testid="sale-seller-data-room"
      aria-labelledby="seller-data-room-heading"
      className="mt-6 rounded border border-slate-500 border-transparent-0 bg-background-canvas p-4 light:border-gray-200 light:bg-gray-100"
    >
      <h2
        id="seller-data-room-heading"
        className="font-heebo text-lg font-medium text-white light:text-gray-900"
      >
        {DATA_ROOM_HEADING}
      </h2>
      <p className="mt-1 text-sm text-gray-400 light:text-gray-700">{SELLER_DATA_ROOM_NOTE}</p>
      <ReviewCopyDataRoom
        saleId={saleId}
        viewAs={viewAs}
        onViewAsChange={setViewAs}
        dataRoomQuery={dataRoomQuery}
        reviewerGrantNote={SELLER_REVIEWER_GRANT_NOTE}
      />
    </section>
  );
};
